// Import model
import { CalendarEventCondition } from '../models/CalendarEventCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { CalendarEventIndexedFields } from '../models/CalendarEventIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { CalendarEventIndexedFieldsSerializer } from './CalendarEventIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CalendarEventCondition - handles JSON serialization and deserialization with type validation
 */
export class CalendarEventConditionSerializer {
  /**
   * Deserializes a JSON string into a CalendarEventCondition instance
   */
  static deserialize(json: string): CalendarEventCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CalendarEventCondition instance
   */
  static fromObject(obj: any): CalendarEventCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CalendarEventCondition');
    }


    const instance: CalendarEventCondition = {
      fieldName: obj['fieldName'] as CalendarEventIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CalendarEventCondition instances
   */
  static deserializeArray(json: string): CalendarEventCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CalendarEventCondition instance to a JSON string
   */
  static serialize(instance: CalendarEventCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CalendarEventCondition instance to a plain object
   */
  static toObject(instance: CalendarEventCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of CalendarEventCondition instances to a JSON string
   */
  static serializeArray(instances: CalendarEventCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
